import { createClient } from 'graphql-ws';

import {
	ApolloClient,
	DefaultOptions,
	from,
	HttpLink,
	InMemoryCache,
	split
} from '@apollo/client';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { getMainDefinition } from '@apollo/client/utilities';

const GRAPHQL_WS_ENDPOINT =
	process.env.NODE_ENV === 'production' &&
	import.meta.env.VITE_APP_GRAPHQL_WS_ENDPOINT
		? import.meta.env.VITE_APP_GRAPHQL_WS_ENDPOINT
		: 'ws://localhost:5000/graphql';
const GRAPHQL_HTTP_ENDPOINT = import.meta.env.VITE_APP_GRAPHQL_HTTP_ENDPOINT
	? import.meta.env.VITE_APP_GRAPHQL_HTTP_ENDPOINT
	: 'http://localhost:5000/graphql';

const productionOptions: DefaultOptions = {
	query: {
		errorPolicy: 'all'
	},
	mutate: {
		errorPolicy: 'all'
	},
	watchQuery: {
		errorPolicy: 'all',
		fetchPolicy: 'cache-and-network'
	}
};

const defaultOptions = productionOptions;

const client = createClient({
	url: GRAPHQL_WS_ENDPOINT,
	lazy: true
});

// Create a WebSocket link:
const wsLink = new GraphQLWsLink(client);

// Create an http link:
const wordpressHttpLink = new HttpLink({
	uri:
		import.meta.env.VITE_APP_WORDPRESS_GRAPHQL_ENDPOINT ??
		'https://biggby.com/graphql'
	// fetchOptions: {
	// 	mode: 'no-cors'
	// } as RequestInit
});

const defaultHttpLink = new HttpLink({
	uri: GRAPHQL_HTTP_ENDPOINT
});

const httpLink = split(
	operation => {
		const context = operation.getContext();

		return context.wordpress;
	},
	wordpressHttpLink,
	defaultHttpLink
);

// const sentryLink = new SentryLink({
// 	attachBreadcrumbs: {
// 		includeQuery: true,
// 		includeError: true
// 	}
// });

// using the ability to split links, you can send data to each link
// depending on what kind of operation is being sent
const splitLink = split(
	// split based on operation type
	({ query }) => {
		const definition = getMainDefinition(query);

		return (
			definition.kind === 'OperationDefinition' &&
			definition.operation === 'subscription'
		);
	},
	wsLink,
	httpLink
);

// const link = from([sentryLink, splitLink]);
const link = from([splitLink]);

const cache = new InMemoryCache({
	typePolicies: {
		Store: {
			keyFields: ['storeId']
		}
	}
});

export const apollo = new ApolloClient({
	link,
	cache,
	defaultOptions
});
